import type { BoardColumn } from "~/shared/types/quote-board-types.ts";

export const INITIAL_COMMODITY_COLUMNS: BoardColumn[] = [
	{
		field: "isDefault",
		title: "Default",
		show: true,
		width: 100,
	},
	{
		field: "description",
		title: "Description",
		show: true,
	},
	{
		field: "quantity",
		title: "Qty",
		show: true,
	},
	{
		field: "freightClass",
		title: "Class",
		show: true,
	},
	{
		field: "unitType",
		title: "Units",
		show: true,
	},
	{
		field: "weight",
		title: "Weight (lbs.)",
		show: true,
	},
	{
		field: "dimensions",
		title: "Dimensions",
		show: true,
	},
	{
		field: "nmfc",
		title: "NMFC Code",
		show: true,
	},
	{
		field: "isStackable",
		title: "Stackable",
		show: true,
	},
	{
		field: "isHazmat",
		title: "Hazmat",
		show: true,
	},
];
